/**
 * Утилиты для работы с черновиками
 * Черновики сохраняются в localStorage
 */

const DRAFT_KEY = 'rosles_draft';

/**
 * Сохраняет черновик в localStorage
 * @param {Object} draftData - Данные для сохранения (JSON, который собирался отправить)
 */
export const saveDraft = (draftData) => {
  try {
    const draft = {
      data: draftData,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    return true;
  } catch (error) {
    console.error('Ошибка при сохранении черновика:', error);
    return false;
  }
};

/**
 * Загружает черновик из localStorage
 * @returns {Object|null} - Данные черновика или null, если черновика нет
 */
export const loadDraft = () => {
  try {
    const draftJson = localStorage.getItem(DRAFT_KEY);
    if (!draftJson) {
      return null;
    }
    const draft = JSON.parse(draftJson);
    return draft;
  } catch (error) {
    console.error('Ошибка при загрузке черновика:', error);
    return null;
  }
};

/**
 * Проверяет, есть ли черновик в localStorage
 * @returns {boolean} - true, если черновик существует
 */
export const hasDraft = () => {
  try {
    const draftJson = localStorage.getItem(DRAFT_KEY);
    return draftJson !== null;
  } catch (error) {
    return false;
  }
};

/**
 * Удаляет черновик из localStorage
 */
export const deleteDraft = () => {
  try {
    localStorage.removeItem(DRAFT_KEY);
    return true;
  } catch (error) {
    console.error('Ошибка при удалении черновика:', error);
    return false;
  }
};

/**
 * Получает информацию о черновике (без данных)
 * @returns {Object|null} - Информация о черновике (timestamp) или null
 */
export const getDraftInfo = () => {
  try {
    const draft = loadDraft();
    if (!draft) {
      return null;
    }
    return {
      timestamp: draft.timestamp,
      hasData: !!draft.data
    };
  } catch (error) {
    return null;
  }
};
